var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossCircleFilled = function SvgCrossCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m2.005-3.423.572-.572a.304.304 0 0 0 0-.43L9.003 8l1.574-1.575a.304.304 0 0 0 0-.43l-.572-.572a.304.304 0 0 0-.43 0L8 6.997 6.425 5.423a.304.304 0 0 0-.43 0l-.572.572a.304.304 0 0 0 0 .43L6.997 8 5.423 9.575a.304.304 0 0 0 0 .43l.572.572a.304.304 0 0 0 .43 0L8 9.003l1.575 1.574a.304.304 0 0 0 .43 0",
    clipRule: "evenodd"
  })));
};
export default SvgCrossCircleFilled;